<div class="change-outlet" [ngClass]="{'mobile': mobile}">
  <div class="change-outlet-title" *ngIf="mobile">
    <span>{{'select-outlet-payer' | translate}}</span>
    <i class="icon icon-close" (click)="clickClose()"></i>
  </div>
  <form [formGroup]="formSuppliersAndOutlets" class="suppliers-outlets-form">
    <div class="form-outlet">
      <app-field-select-input
        class="form-outlet-item"
        [icon]="'icon-shop'"
        [name]="'outletId'"
        [floatLabel]="'none'"
        [group]="formSuppliersAndOutlets"
        [options]="userSuppliersAndOutlets"
        [showParam]="'outletName'"
        [valueParam]="'outletId'"
        [panelClass]="getPanelClass()"
        [fieldClass]="'suppliers-outlets-field'"
        [disableOptionCentering]="true"
      ></app-field-select-input>
    </div>
    <div class="form-item-next" [ngClass]="{'divider': !mobile}" *ngIf="suppliers?.length > 1">
      <app-field-select-input
        class="form-outlet-item"
        [icon]="'icon-shop'"
        [name]="'supplierId'"
        [floatLabel]="'none'"
        [group]="formSuppliersAndOutlets"
        [options]="suppliers"
        [showParam]="'supplierName'"
        [valueParam]="'supplierId'"
        [panelClass]="'suppliers-outlets-panel'"
        [fieldClass]="'suppliers-outlets-field '+ (payers?.length > 0 || isLoginSuperBusinessAdminOrBusinessAdmin ? 'less' : '')"
        [disableOptionCentering]="true"
      ></app-field-select-input>
    </div>
    <div class="form-item-next" [ngClass]="{'divider': !mobile}" *ngIf="payers?.length">
      <app-field-select-input
        class="form-outlet-item"
        [icon]="'icon-user'"
        [name]="'payerId'"
        [floatLabel]="'none'"
        [group]="formSuppliersAndOutlets"
        [options]="payers"
        [showParam]="'payerName'"
        [valueParam]="'payerId'"
        [panelClass]="getPanelClass()"
        [fieldClass]="'suppliers-outlets-field ' + (suppliers.length > 1 || isLoginSuperBusinessAdminOrBusinessAdmin ? 'less' : '')"
        [disableOptionCentering]="true"
      ></app-field-select-input>
    </div>
  </form>
  <div class="action" *ngIf="mobile">
    <button class="btn-secondary" (click)="clickClose()">{{'back' | translate}}</button>
    <button class="btn-primary" (click)="applyChanges()">{{'select' | translate}}</button>
  </div>
</div>
